import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%);
`;

const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid #2d2d44;
  border-top: 4px solid #00d4ff;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 20px;
`;

const Text = styled.div`
  color: #b8b8d1;
  font-size: 18px;
  animation: ${pulse} 2s ease-in-out infinite;
`;

const LoadingSpinner = () => {
  return (
    <Container>
      <Spinner />
      <Text>در حال بارگذاری...</Text>
    </Container>
  );
};

export default LoadingSpinner;
